import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { DEFAULT_PAGE_SIZE } from "src/exercise/exerciseListQuery";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLibraryExercisesPage } from "src/pages/CoachLibraryExercisesPage";
import { createPersonalLibraryExercisesRepository } from "src/repositories/exercises/createPersonalLibraryExercisesRepository";

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  muscleGroup: z.array(z.string()).optional(),
  category: z.array(z.string()).optional(),
  movementPattern: z.array(z.string()).optional(),
  showGlobal: z.boolean().optional(),
  showOwned: z.boolean().optional(),
});

export const Route = createFileRoute("/_auth/_coach/library/exercises/")({
  component: CoachLibraryExercisesPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => ({
    q: search.q ?? "",
    pageIndex: search.p ?? 0,
    pageSize: search.ps ?? DEFAULT_PAGE_SIZE,
    muscleGroup: search.muscleGroup,
    category: search.category,
    movementPattern: search.movementPattern,
    showGlobal: search.showGlobal,
    showOwned: search.showOwned,
  }),
  async loader({ context, deps }) {
    return await loaderHandler(async () => {
      const exercisesRepository = createPersonalLibraryExercisesRepository();
      await context.queryClient.query({
        ...exercisesRepository.listOptions(deps),
        staleTime: "static",
      });
      return { data: null };
    });
  },
});
